import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { collection, onSnapshot } from "firebase/firestore";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { auth, db } from "../Firebase/Config";
import "./App.css";

import Admin, { AdminDashboard } from "../Admin/Admin";
import Service from "../Home-Page/Main/Services/Services";
import About from "../Home-Page/Main/About/About";
import Project from "../Home-Page/Main/Project/Project";
import Contact from "../Home-Page/Main/Contect/Contect";
import CreateService from "../Admin/Showservice/Showservice";
import CreateProject from "../Admin/Showproject/Showproject";
import CreateAbout from "../Admin/ShowAbout/Showabout";
import ShowMessage from "../Admin/ShowMessage/ShowMessage";
import Login from "../Auth/Login";
import Layout from "../Layout/Layout";


const skillFallback = [];
const collectionNames = { services: "service", projects: "project", skills: "about" };

function Site() {
  const scrollToTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const [data, setData] = useState({ services: [], projects: [], skills: skillFallback });
  const [status, setStatus] = useState({ services: "loading", projects: "loading", skills: "loading" });
  const [scrollRevealStarted, setScrollRevealStarted] = useState(false);

  useEffect(() => {
    let revealObserver;
    const startRevealing = () => {
      setScrollRevealStarted(true);
      window.removeEventListener("scroll", startRevealing);

      const elements = document.querySelectorAll("[data-scroll-reveal]");
      if (!("IntersectionObserver" in window)) {
        elements.forEach((element) => element.classList.add("is-visible"));
        return;
      }

      revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -5% 0px" });

      elements.forEach((element) => revealObserver.observe(element));
    };

    window.addEventListener("scroll", startRevealing, { passive: true });
    return () => {
      window.removeEventListener("scroll", startRevealing);
      revealObserver?.disconnect();
    };
  }, []);

  useEffect(() => {
    const unsubscribers = Object.entries(collectionNames).map(([key, collectionName]) => onSnapshot(
      collection(db, collectionName),
      (snapshot) => {
        const nextRecords = snapshot.docs.map((entry) => ({ id: entry.id, ...entry.data() })).sort((a, b) => Number(a.Id || 0) - Number(b.Id || 0));
        setData((current) => ({ ...current, [key]: nextRecords }));
        setStatus((current) => ({ ...current, [key]: "ready" }));
      },
      () => setStatus((current) => ({ ...current, [key]: "error" }))
    ));
    return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
  }, []);

  const renderState = (key, emptyText) => status[key] === "loading" ? <div className="site-data-message">در حال دریافت اطلاعات…</div> : status[key] === "error" ? <div className="site-data-message">بارگذاری این بخش از Firebase ممکن نشد.</div> : data[key].length === 0 ? <div className="site-data-message">{emptyText}</div> : null;

  return (
    <>
      <div className={`site${scrollRevealStarted ? " site-reveal-active" : " site-reveal-pending"}`} dir="rtl">
      <header className="site-nav" data-scroll-reveal>
        <a className="site-brand" href="#home" aria-label="رفتن به ابتدای صفحه"><span className="site-brand-image"><img src="/fav.png" alt="" /></span><b>امیرحسین سیفی</b></a>
        <nav aria-label="ناوبری اصلی"><a href="#services">خدمات</a><a href="#about">درباره من</a><a href="#projects">پروژه‌ها</a><a href="#contact">ارتباط</a></nav>
        <a className="site-nav-cta" href="#contact">شروع گفتگو <span>↗</span></a>
      </header>

      <main>
        <section className="site-hero" id="home" data-scroll-reveal>
          <div className="site-hero-copy"><span className="site-eyebrow"><i /> برنامه‌نویس و طراح وب</span><h1>سلام، من <em>امیرحسین سیفی</em> هستم.</h1><p>برای ساخت تجربه‌های دیجیتال ساده، کاربردی و خوش‌ساخت تلاش می‌کنم.</p><div className="site-actions"><a className="site-button primary" href="#projects">دیدن پروژه‌ها <span>↙</span></a><a className="site-text-link" href="#about">بیشتر دربارهٔ من <span>←</span></a></div><div className="site-hero-meta"><span><b>{data.projects.length || "—"}</b> پروژهٔ ثبت‌شده</span><span><b>{data.services.length || "—"}</b> خدمت قابل ارائه</span></div></div>
          <div className="site-hero-art" role="img" aria-label="فضای کار برنامه‌نویسی"><div className="site-art-note"><span>طراحی</span><b>از ایده تا اجرا</b></div></div>
        </section>

        <section className="site-section site-services" id="services" data-scroll-reveal><div className="site-section-head"><div><span className="site-kicker">چطور کمک می‌کنم</span><h2>خدمات من</h2></div><p>از ایده و طراحی تا ساخت و راه‌اندازی، همراه پروژه‌تان هستم.</p></div>
          {renderState("services", "هنوز خدمتی ثبت نشده است.") || <div className="site-service-grid">{data.services.map((service, index) => <article className="site-service-card" key={service.id}><span className="site-number">{String(service.Id || index + 1).padStart(2, "0")}</span>{service.Picture ? <img className="site-service-icon" src={service.Picture} alt="" /> : <span className="site-service-icon">✳</span>}<h3>{service.Title}</h3><p>{service.Description}</p><a href="#contact" aria-label={`درباره ${service.Title} گفتگو کنیم`}>↙</a></article>)}</div>}
        </section>

        <section className="site-about" id="about" data-scroll-reveal><div className="site-about-intro"><span className="site-kicker">کمی دربارهٔ من</span><h2>فناوری را برای حل مسئله به کار می‌گیرم.</h2><p>من امیرحسین سیفی هستم؛ برنامه‌نویس و طراح وب. از یادگیری ابزارهای تازه و تبدیل ایده‌ها به محصولاتی که استفاده از آن‌ها ساده باشد لذت می‌برم.</p><a className="site-text-link" href="#contact">راه‌های ارتباطی <span>←</span></a></div>
          <div className="site-skills"><div className="site-skill-head"><h3>مهارت‌ها</h3><span>ابزارهایی که در مسیر طراحی و توسعه با آن‌ها کار می‌کنم</span></div>{renderState("skills", "هنوز مهارتی ثبت نشده است.") || <div className="site-skill-list">{data.skills.map((skill) => <span key={skill.id}>{skill.Title}{skill.Size ? ` · ${skill.Size}%` : ""}</span>)}</div>}</div>
        </section>

        <section className="site-section site-projects" id="projects" data-scroll-reveal><div className="site-section-head"><div><span className="site-kicker">چند نمونه از کارها</span><h2>پروژه‌های منتخب</h2></div><p>اینجا نمونه‌ای از پروژه‌ها و تجربه‌هایی را می‌بینی که برای ایده‌ها و نیازهای مختلف طراحی و اجرا کرده‌ام.</p></div>
          {renderState("projects", "هنوز پروژه‌ای ثبت نشده است.") || <div className="site-project-grid">{data.projects.map((project, index) => <article className="site-project-card" key={project.id}><div className={`site-project-art art-${(index % 6) + 1}`}><span>{String(project.Id || index + 1).padStart(2, "0")}</span><b>پروژه</b></div><div className="site-project-copy"><h3>{project.Title}</h3><p>{project.Description}</p>{project.Href && <a href={project.Href} target="_blank" rel="noreferrer">مشاهدهٔ پروژه <span>↗</span></a>}</div></article>)}</div>}
        </section>

        <section className="site-contact" id="contact" data-scroll-reveal><span className="site-kicker">برای همکاری آماده‌ام</span><h2>ایده‌ای در ذهن داری؟</h2><p>دربارهٔ پروژه‌ات صحبت کنیم و ببینیم چطور می‌توانیم آن را به نتیجه برسانیم.</p><div><a href="tel:+989019499640">تماس با من <span>↗</span></a><a href="https://t.me/amirhoseinm0" target="_blank" rel="noreferrer">تلگرام <span>↗</span></a><a href="https://www.instagram.com/amir.hosein.09" target="_blank" rel="noreferrer">اینستاگرام <span>↗</span></a></div></section>
      </main>
      <footer className="site-footer" data-scroll-reveal><a className="site-brand" href="#home"><span className="site-brand-image"><img src="/fav.png" alt="" /></span><b>امیرحسین سیفی</b></a><p>ساخته‌شده با علاقه به وب و جزئیات.</p><a href="#home" onClick={scrollToTop}>بازگشت به بالا <span className="site-back-arrow">↑</span></a></footer>
    </div>
      <aside className="site-vpn-notice" role="note"><p><b>اطلاع‌رسانی:</b> تا فیلترشکن روشن نباشد، اطلاعات سایت نمایش داده نمی‌شود. برای مشاهدهٔ اطلاعات، فیلترشکن را روشن کنید</p></aside>
    </>
  );
}


function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return unsubscribe;
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={user ? <AdminDashboard /> : <Navigate to="/login" state={{ from: "/admin" }} replace />} />
          <Route
            path="/admin/*"
            element={user ? (
              <Admin>
                <Routes>
                  <Route path="/create/service" element={<CreateService />} />
                  <Route path="/create/project" element={<CreateProject />} />
                  <Route path="/create/about" element={<CreateAbout />} />
                  <Route path="/message" element={<ShowMessage />} />
                </Routes>
              </Admin>
            ) : <Navigate to="/login" />}
          />
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                <Route path="/service" element={<Service />} />
                <Route path="/about" element={<About />} />
                <Route path="/project" element={<Project />} />
                <Route path="/contact" element={<Contact />} />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
